import { Outlet, createFileRoute } from '@tanstack/react-router'

import { Spacer } from '@masterplandev/ui'

import { CompanySettingsButton } from '@/app/manager/CompanySettingsButton'
import { Layout, Main, MainContent, TopBar } from '@/app/manager/Layout'
import { Sidebar } from '@/app/manager/Sidebar'
import { SidebarAutoCollapseProvider } from '@/app/manager/SidebarAutoCollapse'
import { TopNavigation } from '@/app/manager/TopNavigation'
import { Notifications } from '@/user/components/Notifications/Notifications'
import { UserMenu } from '@/user/components/UserMenu/UserMenu'

export const Route = createFileRoute('/company/_management')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <SidebarAutoCollapseProvider>
      <Layout data-testid="company-layout">
        <Sidebar />
        <Main>
          <TopBar>
            <TopNavigation />
            <Spacer />
            <Notifications tenant="company-space" />
            <CompanySettingsButton />
            <UserMenu section="company-space" />
          </TopBar>
          <MainContent>
            <Outlet />
          </MainContent>
        </Main>
      </Layout>
    </SidebarAutoCollapseProvider>
  )
}
